export default __webpack_public_path__ + "static/media/logs_4.57dd4257.png";